"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuncDataSourceType = exports.FuncDataSource = exports.FuncCustomVariable = exports.RunStreamResponseStreamResult = exports.RunStreamResponse = exports.FuncResponse = exports.FuncResponseType = exports.FunctionBase = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const StoryNodeDisplayType_1 = require("../domain/StoryNodeDisplayType");
class FunctionBase {
    constructor(brainClient, authStore, socketRestClient) {
        this.brainClient = brainClient;
        this.authStore = authStore;
        this.socketRestClient = socketRestClient;
    }
    // TODO: input 定义优化，统一传入 SearchInfoPagination，去掉 page 和 next
    async run(input, identityInfo, variableList = [], page = 1, next = undefined, // for food
    pagination = undefined, // for youtube
    requestParams = {}, // for additional required data
    checkAbort, sourceNodeType = StoryNodeDisplayType_1.StoryNodeDisplayType.TEXT, queries = [], blueprintJSON = "", graphData) {
        return Promise.reject();
    }
}
exports.FunctionBase = FunctionBase;
var FuncResponseType;
(function (FuncResponseType) {
    FuncResponseType["TEXT"] = "TEXT";
    FuncResponseType["STREAM_TEXT"] = "STREAM_TEXT";
    FuncResponseType["STRING_GROUP"] = "STRING_GROUP";
    FuncResponseType["STOCK"] = "STOCK";
    FuncResponseType["STOCK_GROUP"] = "STOCK_GROUP";
    FuncResponseType["AMAZON_SHOPPING"] = "AMAZON_SHOPPING";
    FuncResponseType["JD_SHOPPING"] = "JD_SHOPPING";
    FuncResponseType["YOUTUBE_VIDEOS"] = "YOUTUBE_VIDEOS";
    FuncResponseType["WEEE_GROCERIES"] = "WEEE_GROCERIES";
    FuncResponseType["WEEE_SHOPPING"] = "WEEE_SHOPPING";
    FuncResponseType["MAP"] = "MAP";
    FuncResponseType["IMAGE_GROUP"] = "IMAGE_GROUP";
    FuncResponseType["FOOD"] = "FOOD";
    FuncResponseType["ASK_BRAIN"] = "ASK_BRAIN";
    FuncResponseType["PROTEIN"] = "PROTEIN";
    FuncResponseType["MIDJOURNEY"] = "MIDJOURNEY";
    FuncResponseType["IMAGE_TEXT"] = "IMAGE_TEXT";
    FuncResponseType["CHAT_INTERFACE"] = "CHAT_INTERFACE";
    FuncResponseType["CUSTOM_API"] = "CUSTOM_API";
    FuncResponseType["INTERVIEW_BOT"] = "INTERVIEW_BOT";
    FuncResponseType["BLUEPRINT"] = "BLUEPRINT";
    FuncResponseType["FUNCTION_V2"] = "FUNCTION_V2";
})(FuncResponseType || (exports.FuncResponseType = FuncResponseType = {}));
class FuncResponse {
    constructor(type, data) {
        this.type = type;
        this.data = data;
    }
}
exports.FuncResponse = FuncResponse;
class RunStreamResponse {
    constructor() {
        this.eventEmitter = new eventemitter3_1.default();
        this.response = undefined;
    }
    onReceived(listener) {
        if (this.response) {
            listener(this.response);
        }
        this.eventEmitter.on(RunStreamResponse.RECEIVED_EVENT, msg => {
            listener(msg);
        });
    }
    receive(newValue, completion, error) {
        const result = new RunStreamResponseStreamResult(newValue, completion, error);
        this.response = result;
        if (this.eventEmitter.listenerCount(RunStreamResponse.RECEIVED_EVENT) > 0) {
            this.eventEmitter.emit(RunStreamResponse.RECEIVED_EVENT, result);
        }
    }
    /**
     * streamResponse 转为 promise, 当completion = true || error != empty，代表结束。
     */
    promise() {
        const promise = new Promise((resolve, reject) => {
            this.onReceived(result => {
                if (!result.completion) {
                    return;
                }
                if (result.error) {
                    reject(result.error);
                    return;
                }
                resolve(result.value);
            });
        });
        return promise;
    }
}
exports.RunStreamResponse = RunStreamResponse;
RunStreamResponse.RECEIVED_EVENT = "RunStreamResponseReceived";
class RunStreamResponseStreamResult {
    constructor(value, completion, error) {
        this.value = value;
        this.completion = completion;
        this.error = error;
    }
}
exports.RunStreamResponseStreamResult = RunStreamResponseStreamResult;
class FuncCustomVariable {
    constructor(name, value) {
        this.name = name;
        this.value = value;
    }
}
exports.FuncCustomVariable = FuncCustomVariable;
class FuncDataSource {
    constructor(type, value, isEnded = true) {
        this.type = type;
        this.value = value;
        this.isEnded = isEnded;
    }
}
exports.FuncDataSource = FuncDataSource;
var FuncDataSourceType;
(function (FuncDataSourceType) {
    FuncDataSourceType["ASK_BRAIN"] = "ASK_BRAIN";
    FuncDataSourceType["TEXT"] = "TEXT";
    FuncDataSourceType["STRING_GROUP"] = "STRING_GROUP";
    FuncDataSourceType["IMAGE_TEXT"] = "IMAGE_TEXT";
    FuncDataSourceType["CUSTOMAPI"] = "CUSTOMAPI";
    FuncDataSourceType["INTERVIEW_BOT"] = "INTERVIEW_BOT";
    FuncDataSourceType["AMAZON_SHOPPING"] = "AMAZON_SHOPPING";
    FuncDataSourceType["WEEE_GROCERIES"] = "WEEE_GROCERIES";
    FuncDataSourceType["WEEE_SHOPPING"] = "WEEE_SHOPPING";
    FuncDataSourceType["JD_SHOPPING"] = "JD_SHOPPING";
    FuncDataSourceType["MAP"] = "MAP";
    FuncDataSourceType["FOOD"] = "FOOD";
    FuncDataSourceType["PROTEIN"] = "PROTEIN";
    FuncDataSourceType["DEFAULT"] = "DEFAULT";
})(FuncDataSourceType || (exports.FuncDataSourceType = FuncDataSourceType = {}));
